export default __webpack_public_path__ + "static/prof3-3fcad91208a6e99178c2bf275e1a7560.png";